import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { VseAlertContainer } from '../alert/VseAlertContainer';
import * as UserRegister from '../../features/account';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
  },
}));

export function ConfirmEmailPage() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const userRegisterState = UserRegister.useUserRegisterState();
  const location = useLocation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const i = params.get('i');
    const c = params.get('c');
    dispatch(UserRegister.confirmEmail({ encodedId: i ? i : '', encodedCode: c ? c : '' }));

    return function cleanup() {
      dispatch(UserRegister.reset());
    }
  }, [dispatch, location.search]);


  switch (userRegisterState.emailConfirmation) {
    case 'failed':
      return (
        <main className={classes.root}>
          <VseAlertContainer />
        </main>
      );

    case 'succeeded':
      return (
        <main className={classes.root}>
          <Paper className={classes.paper}>
            <Typography variant='h6'>Account Activated</Typography>
            <Typography variant='body1'>Your account has been activated. <Link to={'/login'}>Login to your account</Link>.</Typography>
          </Paper>
        </main>
      );

    default:
      return (
        <Backdrop open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      );
  }
}
